var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { addI18nMessages, useLocale, getLocale } from "./locale/index.js";
import Button from "./button/index.js";
import Link from "./link/index.js";
import Typography from "./typography/index.js";
import Divider from "./divider/index.js";
import Grid from "./grid/index.js";
import Layout from "./layout/index.js";
import Space from "./space/index.js";
import Avatar from "./avatar/index.js";
import Badge from "./badge/index.js";
import Card from "./card/index.js";
import Carousel from "./carousel/index.js";
import Collapse from "./collapse/index.js";
import Comment from "./comment/index.js";
import Descriptions from "./descriptions/index.js";
import Empty from "./empty/index.js";
import Image from "./image/index.js";
import List from "./list/index.js";
import Popover from "./popover/index.js";
import Statistic from "./statistic/index.js";
import Table from "./table/index.js";
import Tabs from "./tabs/index.js";
import Tag from "./tag/index.js";
import Timeline from "./timeline/index.js";
import Tooltip from "./tooltip/index.js";
import AutoComplete from "./auto-complete/index.js";
import Cascader from "./cascader/index.js";
import Checkbox from "./checkbox/index.js";
import DatePicker from "./date-picker/index.js";
import Form from "./form/index.js";
import Input from "./input/index.js";
import InputNumber from "./input-number/index.js";
import InputTag from "./input-tag/index.js";
import Mention from "./mention/index.js";
import Radio from "./radio/index.js";
import Rate from "./rate/index.js";
import Select from "./select/index.js";
import Slider from "./slider/index.js";
import Switch from "./switch/index.js";
import Textarea from "./textarea/index.js";
import TimePicker from "./time-picker/index.js";
import Transfer from "./transfer/index.js";
import Tree from "./tree/index.js";
import Upload from "./upload/index.js";
import TreeSelect from "./tree-select/index.js";
import Alert from "./alert/index.js";
import Drawer from "./drawer/index.js";
import Message from "./message/index.js";
import Modal from "./modal/index.js";
import Notification from "./notification/index.js";
import Popconfirm from "./popconfirm/index.js";
import Progress from "./progress/index.js";
import Result from "./result/index.js";
import Spin from "./spin/index.js";
import Skeleton from "./skeleton/index.js";
import Breadcrumb from "./breadcrumb/index.js";
import Dropdown from "./dropdown/index.js";
import Menu from "./menu/index.js";
import PageHeader from "./page-header/index.js";
import Pagination from "./pagination/index.js";
import Steps from "./steps/index.js";
import Affix from "./affix/index.js";
import Anchor from "./anchor/index.js";
import BackTop from "./back-top/index.js";
import ConfigProvider from "./config-provider/index.js";
import ResizeBox from "./resize-box/index.js";
import Trigger from "./trigger/index.js";
import Split from "./split/index.js";
const components = {
  Button,
  Link,
  Typography,
  Divider,
  Grid,
  Layout,
  Space,
  Avatar,
  Badge,
  Card,
  Carousel,
  Collapse,
  Comment,
  Descriptions,
  Empty,
  Image,
  List,
  Popover,
  Statistic,
  Table,
  Tabs,
  Tag,
  Timeline,
  Tooltip,
  AutoComplete,
  Cascader,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  InputTag,
  Mention,
  Radio,
  Rate,
  Select,
  Slider,
  Switch,
  Textarea,
  TimePicker,
  Transfer,
  Tree,
  Upload,
  TreeSelect,
  Alter: Alert,
  Drawer,
  Message,
  Modal,
  Notification,
  Popconfirm,
  Progress,
  Result,
  Spin,
  Skeleton,
  Breadcrumb,
  Dropdown,
  Menu,
  PageHeader,
  Pagination,
  Steps,
  Affix,
  Anchor,
  BackTop,
  ConfigProvider,
  ResizeBox,
  Trigger,
  Split
};
const install = (app, options) => {
  for (const key of Object.keys(components)) {
    app.use(components[key], options);
  }
};
const ArcoVue = __spreadProps(__spreadValues({}, components), {
  install,
  addI18nMessages,
  useLocale,
  getLocale
});
export { ArcoVue as default };
